const toZeroUTCOnCurrentDay = (date: Date, options?: { isLastMillisecond?: boolean }) => {
  const { isLastMillisecond = false } = options || {}

  if (isLastMillisecond) {
    const _date = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1, 0, 0, 0, 0)

    _date.setMilliseconds(-1)

    return _date.toISOString()
  }

  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0).toISOString()
}

export default toZeroUTCOnCurrentDay
